/* tslint:disable */

import { BaseComponentFilter } from './BaseComponentFilter';
import { ComponentState } from './ComponentState';
import { ComponentType } from './ComponentType';

export class ExtendedComponentFilter extends BaseComponentFilter {
  componentSubTypes?: { [key in ComponentType]: number };
  componentStates?: ComponentState[];
  authorId?: string | null;
  reviewerId?: string | null;
}
